import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IndustryTypeService } from 'src/app/shared/services/industry-type-services/industry-type.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-user-registration-form',
  templateUrl: './user-registration-form.component.html',
})
export class UserRegistrationFormComponent implements OnInit {
  errorMessage1: string = '';
  createUserForm!: FormGroup;
  industryTypeList: any = [];
  rolesList: any = [];
  showPortalBuilder: any;
  userRole: any;
  urlPattern =
    '^((https?|ftp|smtp):\\/\\/)?(www.)?[a-z0-9]+([\\-.]{1}[a-z0-9]+)*\\.[a-z]{2,5}' +
    '((\\/[\\w\\-]+)*\\/)?([\\w\\-]+\\.[\\w]{2,4}(\\?[\\w\\-]+=[\\w\\-]+)?)?$';
  showResellerCode: boolean = false;
  showMerchantCode: boolean = false;
  showCustomerProfile: boolean = false;
  selectedIndustryType: any;
  selectedRole: any = {
    title: '',
  };
  referalName: string = 'Full Name';
  user: any;
  showPassword = true;
  roleOnboading: any = '';
  loginUserType: any;
  imageurl: any;
  file: any;
  constructor(
    private formBuilder: FormBuilder,
    private readonly userAuthService: UserService,
    private router: Router,
    private readonly toastrMsgService: ToastrMsgService,
    private readonly industryTypeService: IndustryTypeService
  ) {}

  ngOnInit() {
    this.userRole = this.userAuthService.getUserRole();
    this.user = this.userAuthService.getUserDetailsFromSession();
    console.log(this.user)
    if (this.userRole == 'partner') {
      this.roleOnboading = 'Reseller';
    }
    if (this.userRole == 'admin') {
      this.roleOnboading = 'Partner';
    }
    if (this.userRole == 'reseller') {
      this.roleOnboading = 'Merchant';
    }
    if (this.userRole == 'merchant') {
      this.router.navigate(['/home/customer/kyc']);
    }
    this.createUserForm = this.formBuilder.group({
      name: ['', Validators.required],
      role: ['', Validators.required],
      industryType: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
          ),
        ],
      ],
      phone: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(/^[6-9]\d{9}$/),
        ],
      ],
      alternatePhone: [
        '',
        [Validators.maxLength(10), Validators.pattern(/^[6-9]\d{9}$/)],
      ],
      businessName: ['', Validators.required],
      website: ['', [Validators.required, Validators.pattern(this.urlPattern)]],
      merchantCode: ['', [Validators.maxLength(5)]],
      resellerCode: ['', [Validators.maxLength(5)]],
    });
    if (this.userRole == 'partner' || this.userRole == 'reseller') {
      this.createUserForm
        .get('businessName')
        ?.patchValue(this.user?.businessName);
    }
    this.getUserType();
    this.getIndustryType();
  }

  getUserType() {
    let payload = {
      limit: 10000,
      currentPage: 1,
    };
  }

  getIndustryType() {
    let payload = {
      limit: 10000,
      currentPage: 1,
    };
    this.industryTypeService.getIndustryTypes(payload).subscribe((res) => {
      this.industryTypeList = res.data.data;
    });
  }

  createUser() {
    const payload = { ...this.createUserForm.getRawValue() };
    if (this.selectedRole.title == 'Partner') {
      payload.shortName = (Math.random() + 1).toString(36).substring(7);
    } else {
      payload.shortName = this.createUserForm.controls['merchantCode']
        ? this.createUserForm.controls['merchantCode'].value
        : this.createUserForm.controls['resellerCode']
        ? this.createUserForm.controls['resellerCode'].value
        : undefined;
    }
    delete payload.merchantCode;
    delete payload.resellerCode;

    payload.role = {
      title: this.selectedRole?.title,
      type: this.selectedRole?.type,
      roleId: this.selectedRole?._id,
    };
    payload.industryType = {
      title: this.selectedIndustryType?.title,
      type: this.selectedIndustryType?.type,
      industryTypeId: this.selectedIndustryType?._id,
    };
    console.log(this.createUserForm);
    if (this.createUserForm?.valid) {
      this.userAuthService.createUser(payload).subscribe({
        next: (res) => {
          this.toastrMsgService.success('Customer created Successfully');

          if (this.showPortalBuilder) {
            this.router.navigate([
              '/home/customer/addEditPortalBuilder',
              res.data._id,
              true,
            ]);
          } else {
            this.router.navigate(['/home/customer/customerProfile']);
          }
        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => console.log('Observable complete'),
      });
    } else {
      this.createUserForm.markAllAsTouched();
      this.toastrMsgService.warning('Please fill the mandatory fields');
    }
  }
  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  getRoleData(event: any) {
    this.selectedRole = this.rolesList.find(
      (item: any) => item._id == event.target.value
    );
    if (this.selectedRole.title == 'Partner') {
      this.showPortalBuilder = true;
      this.showCustomerProfile = false;
      this.referalName = 'Reference Person Name';
    } else if (this.selectedRole.title == 'Reseller') {
      this.referalName = 'Reseller Name';
      this.showPortalBuilder = false;
      this.showCustomerProfile = true;
      this.createUserForm
        .get('resellerCode')
        ?.addValidators(Validators.required);
      this.createUserForm.get('resellerCode')?.updateValueAndValidity();
      this.createUserForm.get('merchantCode')?.clearValidators();
      this.createUserForm.get('merchantCode')?.updateValueAndValidity();
    } else if (this.selectedRole.title == 'Merchant') {
      this.referalName = 'Merchant Name';
      this.showPortalBuilder = false;
      this.showCustomerProfile = true;
      this.createUserForm
        .get('merchantCode')
        ?.addValidators(Validators.required);
      this.createUserForm.get('merchantCode')?.updateValueAndValidity();
      this.createUserForm.get('resellerCode')?.clearValidators();
      this.createUserForm.get('resellerCode')?.updateValueAndValidity();
    }
  }

  getIndustryTypeData(event: any) {
    this.selectedIndustryType = this.industryTypeList.find(
      (item: any) => item._id == event.target.value
    );
  }

  get isMerchant() {
    const l = this.rolesList.find(
      (r: any) =>
        r._id == (this.createUserForm as any).controls?.['role']?.value
    );
    return l?.type === 'merchant';
  }

  get isReseller() {
    const l = this.rolesList.find(
      (r: any) =>
        r._id == (this.createUserForm as any).controls?.['role']?.value
    );
    return l?.type === 'reseller';
  }

  handleFileInput(event: any) {
    this.file = event.target.files[0];
    const fileSize = this.file.size / 1024 / 1024; // Convert bytes to KB
    const fileType = this.file.type;

    if (!this.file) {
      this.errorMessage1 = 'No file chosen.';
      return;
    }

    if (fileType !== 'image/jpeg' && fileType !== 'image/png') {
      this.errorMessage1 = 'File should be JPEG or PNG.';
      return;
    }

    if (fileSize > 3) {
      this.errorMessage1 = 'File size should be less than 3 MB.';
      return;
    }

    this.imageurl = URL.createObjectURL(this.file);
    // Update the 'upload' FormControl value with the file
    // this.uploadImgAPI(this.file?.type, this.folderName, this.file);
    // this.errorMessage = 'Uploaded';
  }
}
